<template>
  <div>
    <v-navigation-drawer v-model="drawer" :permanent="isPermanent" fixed app>
      
      <a :href="baseUrl">
        <img :src="appLogo" alt="UII Logo" width="250" style="vertical-align: middle" class="mr-1 pa-5" />
        <div class="text-h5 font-weight-bold pt-0 pl-5 mb-0">
          {{ this.$t('app_name') }}
        </div>
      </a>
      <!-- <div class="text-h4 font-weight-bold pt-0 pl-5 mt-0 mb-6 indigo--text text--darken-4">
        {{
          this.$t('app_name').indexOf(" ") === -1
            ? ""
            : this.$t('app_name').substring(this.$t('app_name').indexOf(" ") + 1)
        }}
      </div> -->
      <v-list nav dense>
        <!--====== Mahasiswa =======-->
        <template v-if="role.includes(4)">
          <div class="text-h7 font-weight-bold pt-0 pl-5 mt-0 mt-6 mb-0 indigo--text text--darken-4">
            {{ this.$t('student_menu') }}
          </div>
          <v-list-item-group active-class="indigo--text text--darken-4">
            <v-list-item :to="{ name: 'home' }">
              <v-list-item-icon>
                <v-icon>mdi-account-hard-hat-outline</v-icon>
                <v-badge color="red" dot bordered overlap></v-badge>
              </v-list-item-icon>
              <v-list-item-title>{{ this.$t('internship') }}</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'help-and-information-student' }">
              <v-list-item-icon>
                <v-icon>mdi-help-circle-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ this.$t('help_and_information') }}</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </template>
        <!--====== End Mahasiswa =======-->

        <!--====== Prodi =======-->
        <template v-if="role.includes(2)">
          <div class="text-h7 font-weight-bold pt-0 pl-5 mt-0 mt-6 mb-0 indigo--text text--darken-4">
            {{ this.$t('officer_menu') }}
          </div>
          <v-list-item-group active-class="indigo--text text--darken-4 ">
            <!-- <v-list-item :to="{ name: 'home-officer' }">
            <v-list-item-icon>
              <v-icon>mdi-home-analytics</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Ikhtisar
            </v-list-item-title>
          </v-list-item> -->
            <v-list-item :to="{ name: 'verify-officer' }">
              <v-list-item-icon>
                <v-icon>mdi-file-document-multiple-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ this.$t('registration_verification') }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'validate-officer' }">
              <v-list-item-icon>
                <v-icon>mdi-file-check</v-icon>
              </v-list-item-icon>
              <v-list-item-title> {{ this.$t('letter_verification') }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'recapitulation-internship-officer' }">
              <v-list-item-icon>
                <v-icon>mdi-chart-bar</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ this.$t('recap_student') }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'manage-letter.index' }" v-if=$isFTI>
              <v-list-item-icon>
                <v-icon>mdi-email-multiple-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ this.$t('manage_letter') }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'manage-rubric.index' }" v-if=$isFTI>
              <v-list-item-icon>
                <v-icon>mdi-puzzle-edit-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ this.$t('manage_rubric') }}
              </v-list-item-title>
            </v-list-item>
            <!-- <v-list-item :to="{ name: 'manage-faq.index' }">
            <v-list-item-icon>
              <v-icon>mdi-help</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Kelola FAQ
            </v-list-item-title>
          </v-list-item> -->
            <v-list-item :to="{ name: 'recapitulation-lecture-officer' }">
              <v-list-item-icon>
                <v-icon>mdi-chart-box</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Rekapitulasi Dosen
              </v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </template>

        <!--====== End Prodi =======-->

        <!--====== Dosen =======-->
        <template v-if="role.includes(3)">
          <div class="text-h7 font-weight-bold pt-0 pl-5 mt-0 mt-6 mb-0 indigo--text text--darken-4">
            {{ this.$t('lecture_menu') }}
          </div>
          <v-list-item-group active-class="indigo--text text--darken-4 ">
            <v-list-item :to="{ name: 'home-lecturer' }">
              <v-list-item-icon>
                <!-- <v-badge color="red" content="6" xs overlap > -->
                <v-icon>mdi-account-multiple-outline</v-icon>
                <!-- </v-badge> -->
              </v-list-item-icon>
              <v-list-item-title>{{ this.$t('guidance_students') }}
              </v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </template>
        <!--====== End Dosen =======-->

        <!--====== Admin =======-->
        <template v-if="role.includes(1)">
          <div class="text-h7 font-weight-bold pt-0 pl-5 mt-0 mt-6 mb-0 indigo--text text--darken-4">
            {{ this.$t('admin_menu') }}
          </div>
          <v-list-item-group active-class="indigo--text text--darken-4 ">
            <v-list-item :to="{ name: 'setting-users.index' }">
              <v-list-item-icon>
                <v-icon>mdi-account-group</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ this.$t('manage_user') }}
              </v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </template>
        <!--====== End Admin =======-->


      </v-list>
    </v-navigation-drawer>
    <v-app-bar dense>
      <v-app-bar-nav-icon v-if="$vuetify.breakpoint.mdAndDown" color="black" @click="drawer = true"></v-app-bar-nav-icon>

      <!-- <v-toolbar-title>Page title</v-toolbar-title> -->

      <v-spacer></v-spacer>
      <!-- <v-menu right bottom class="mr-3">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon dark> mdi-translate </v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-if="this.$i18n.locale === 'en'" @click="setLocale('id')">
            <v-list-item-title>{{ $t('id_lang') }}</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="this.$i18n.locale === 'id'" @click="setLocale('en')">
            <v-list-item-title>{{ $t('en_lang') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu> -->
      <label class="text-center">{{
        user.name
      }}</label>
      <v-menu right bottom class="mr-3">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <div v-if="user && user.avatar">
              <v-avatar size="30">
                <v-img :src="user.avatar"></v-img>
              </v-avatar>
            </div>
            <div v-else>
              <v-icon dark> mdi-account-circle </v-icon>
            </div>
          </v-btn>
        </template>
        <v-list>
          <v-list-item :to="{ name: 'profile' }">
            <v-list-item-title><v-icon left small>mdi-account-circle</v-icon>Profil</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'help-and-information-student' }">
            <v-list-item-title><v-icon left small>mdi-help</v-icon>Bantuan</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout">
            <v-list-item-title><v-icon left small>mdi-logout</v-icon> {{ $t('logout') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>
<script>
export default {
  data: () => ({
    app_name: process.env.MIX_APP_NAME,
    drawer: false,
    user: JSON.parse(localStorage.getItem("user")),
    role: '',
    appLogo: process.env.MIX_APP_LOGO,
    onVerification: '0',
    baseUrl: ''
  }),

  computed: {
    isPermanent() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return false;
        case "sm":
          return false;
        case "md":
          return true;
        case "lg":
          return true;
        case "xl":
          return true;
      }
    },
  },
  created() {
    vm.appComponent = this;
    this.role = this.user.roles.map(ro => {
      return ro.id;
    })
    if (this.role.includes(2)) this.onOfficerLogin(this.roles);
    this.baseUrl = this.$baseurl;
  },
  methods: {
    onOfficerLogin() {
      // this.axios.get("/api/verifikasi/pendaftaran/").then((response) => {
      //   this.onVerification = response.data.data.length;
      // })
    },
    logout() {
      this.axios.get("/sanctum/csrf-cookie").then((response) => {
        this.axios.post("/api/auth/logout").then((response) => {
          if (response.status === 200) {
            localStorage.setItem("isAuth", "");
            localStorage.setItem("user", "");
            this.$router.push({ name: "auth", params: {} });
          }
        });
      });
    },
    setLocale(locale) {
      localStorage.setItem("locale", locale);
      location.reload();
    }
  },
};
</script>